import {Dialog, DialogContent} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import React from "react";
import PropTypes from "prop-types";
import {useSearchResultDetailsState} from "./SearchResultDetailsContext";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {useDocumentTranslation} from "../documents/documentContext";

/**
 * Dialog framework used when displaying the option dialog when downloading image-, audio- or video files.
 * @param title
 * @param content
 * @param open
 * @param cancelHandler
 * @param closeHandler
 * @returns {JSX.Element}
 * @constructor
 */
const DownloadOptionsDialog = ({title, content, open, cancelHandler, closeHandler}) => {
    const t = useDocumentTranslation();

    const {model} = useSearchResultDetailsState();

    const hasCopyrightClause = () => {
        if (!model?.content) {
            return false;
        }
        const {copyrightInfo = []} = model.content;
        return copyrightInfo.length > 0;
    };

    return <Dialog open={open}>
        <DialogTitle>
            {title}
        </DialogTitle>
        <DialogContent>
            {content}
            {hasCopyrightClause() &&
                <Box sx={{marginTop: '16px'}}>
                    <Alert severity="warning" icon={<WarningAmberIcon/>}>
                        <b>{t('obs', 'OBS')}</b>: {t('clausedFileDownload', 'Filen du laster ned er klausulert. Undersøk om du kan bruke filen før du laster ned.')}
                    </Alert>
                </Box>
            }
        </DialogContent>
        <DialogActions>
            <Button onClick={cancelHandler}>
                {t("btnCancel", "Avbryt")}
            </Button>
            <Button
                color="primary"
                variant="contained"
                onClick={closeHandler}
            >
                {t("btnOk", "Ok")}
            </Button>
        </DialogActions>
    </Dialog>;
};

DownloadOptionsDialog.propTypes = {
    "title": PropTypes.string.isRequired,
    "open": PropTypes.bool.isRequired,
    "cancelHandler": PropTypes.func.isRequired,
    "closeHandler": PropTypes.func.isRequired
};

export {DownloadOptionsDialog};